import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandCategory } from '@/interfaces/Menu';
import { BottomSheet } from '../BottomSheet/BottomSheet';
import styles from './MenuCategoriesBottomSheet.module.scss';
import { BrandCategoryWithCount } from './types';

interface MenuCategoriesModalProps {
  onClose?: () => void;
  onConfirm: (category: BrandCategory) => void;
  categories: BrandCategoryWithCount[];
  activeCategory: BrandCategory | null;
}

const MenuCategoriesModal = ({
  onClose,
  categories,
  onConfirm,
  activeCategory,
}: MenuCategoriesModalProps) => {
  const [shouldClose, setShouldClose] = useState(false);
  const { t } = useTranslation();

  const goToCategory = (category: BrandCategory) => {
    onConfirm(category);
    setShouldClose(true);
  };

  return (
    <div className={styles.menuCategoriesModal} data-testid="menu-categories-modal">
      <BottomSheet closable={true} onClose={onClose} noVerticalPadding shouldClose={shouldClose}>
        <h3 className={styles.title}>{t('menuCategories.jumpTo')}</h3>
        <div className={styles.menuCategoriesModalContent}>
          {categories.map(category => (
            <div
              key={category.id}
              className={styles.menuCategoryItem}
              onClick={() => goToCategory(category)}
              data-testid={`category-item-${category.id}`}
            >
              <div
                className={`${activeCategory?.id === category.id ? styles.highlightBar : ''}`}
                data-testid={activeCategory?.id === category.id ? 'highlight-bar' : undefined}
              />
              <div className={styles.menuCategoryItemContent}>
                <p className={styles.menuCategoryItemName}>{category.name}</p>
                <p className={styles.menuCategoryItemCount}>{category.numberOfItems}</p>
              </div>
            </div>
          ))}
        </div>
      </BottomSheet>
    </div>
  );
};

export default MenuCategoriesModal;
